import React from 'react';

interface CountdownProps {
  dateTime: Date | string;
}

const Countdown: React.FC<CountdownProps> = ({ dateTime }) => {
  const [timeLeft, setTimeLeft] = React.useState<{
    hours: string;
    minutes: string;
    seconds: string;
  }>({
    hours: '08',
    minutes: '00',
    seconds: '00',
  });
  const [isReady, setIsReady] = React.useState(false);

  React.useEffect(() => {
    const targetDate = dateTime instanceof Date ? dateTime : new Date(dateTime);

    if (isNaN(targetDate.getTime())) {
      console.error('Invalid date provided to Countdown component');
      return;
    }

    // Calculate initial time difference
    const now = new Date();
    const timeDiff = targetDate.getTime() - now.getTime();

    // Set initial values before showing the countdown
    const hours = `0${Math.floor(
      (timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    )}`.slice(-2);
    const minutes = `0${Math.floor(
      (timeDiff % (1000 * 60 * 60)) / (1000 * 60)
    )}`.slice(-2);
    const seconds = `0${Math.floor((timeDiff % (1000 * 60)) / 1000)}`.slice(-2);

    setTimeLeft({
      hours,
      minutes,
      seconds,
    });
    setIsReady(true);

    const interval = setInterval(() => {
      const now = new Date();
      const timeDiff = targetDate.getTime() - now.getTime();

      if (timeDiff <= 0) {
        clearInterval(interval);
        setTimeLeft({
          hours: '00',
          minutes: '00',
          seconds: '00',
        });
        return;
      }

      const hours = `0${Math.floor(
        (timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      )}`.slice(-2);
      const minutes = `0${Math.floor(
        (timeDiff % (1000 * 60 * 60)) / (1000 * 60)
      )}`.slice(-2);
      const seconds = `0${Math.floor((timeDiff % (1000 * 60)) / 1000)}`.slice(
        -2
      );

      setTimeLeft({
        hours,
        minutes,
        seconds,
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [dateTime]);

  if (!isReady) {
    return null;
  }

  return (
    <div className="flex flex-row items-center">
      <span className="text-lg font-bold">{`${timeLeft.hours}:${timeLeft.minutes}:${timeLeft.seconds}`}</span>
    </div>
  );
};

export default Countdown;
